<header class="header w-full flex flex-col gap-1 mb-4 px-1">
  <h1 class="text-2xl md:text-3xl font-bold text-primary-700">{{ text }}</h1>
  <small class="text-sm text-ink-500">
    {{ dateVal | date : 'd בMMM y, HH:mm' : '' : 'he-IL' }}
  </small>
</header>
